
export const ErrorPage = () => {
  return (
    <div className="text-center p-10 text-2xl ">
      Beklager, der skete en fejl
    </div>
  );
}